import { render, staticRenderFns } from "./FilterWalletMobile.vue?vue&type=template&id=8855c368"
import script from "./FilterWalletMobile.vue?vue&type=script&lang=ts"
export * from "./FilterWalletMobile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports